export const generateShaHash = async (
  inputString: string,
  algorithm: string = 'SHA-256',
) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(inputString)
  const hash = await window.crypto.subtle.digest(algorithm, data)
  const hashArray = Array.from(new Uint8Array(hash))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
